namespace Areas {
    "use strict";

    export class EditBatchButtonConfiguration {
        private readonly toolbarOptions: any;

        constructor(toolbarOptions: any) {
            this.toolbarOptions = toolbarOptions;
        }

        configureBatchEditButtons() {
            const saveBtnItem = this.toolbarOptions.items.find(item => item.name === "saveButton");
    
            if (saveBtnItem) {
                saveBtnItem.showText = "always";
                saveBtnItem.options.icon = "save";
                saveBtnItem.options.type = "success";
                saveBtnItem.options.text = "Save";
            }
    
            const revertBtnItem = this.toolbarOptions.items.find(item => item.name === "revertButton");
    
            if (revertBtnItem) {
                revertBtnItem.showText = "always";
                revertBtnItem.options.icon = "revert";
                revertBtnItem.options.type = "default";
                revertBtnItem.options.elementAttr = { class: "cancel" };
                revertBtnItem.options.text = "Cancel"; 
            }
    
            const addBtnItem = this.toolbarOptions.items.find(item => item.name === "addRowButton");
            
            if (addBtnItem) {
                addBtnItem.showText = "always";
                addBtnItem.options.icon = "plus";
                addBtnItem.options.type = "default";
                addBtnItem.options.elementAttr = { class: "add" };
                addBtnItem.options.text = "Add";   
            }        
        }
    }
}